export default "__VITE_ASSET__CxXNej_7__"